import { Skeleton } from "antd";
import { Div, Text, Col } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { getSequentialCardStyles } from "../../../utilities/helpers";
import { ChevronRightIcon, DataIcon } from "../../../assets/icons";

export const SurveyCard = ({ survey, isMobile, onCardClick, status }) => {
    const styles = getSequentialCardStyles(survey.categoryId);
    
    return (
      <Div
        width={!isMobile ? "31%" : "100%"}
        minHeight="120px"
        radius="24px"
        background={styles.background}
        align="left"
        p="20px 17px 20px 24px"
        onClick={onCardClick}
        style={{ 
          cursor: "pointer",
          position: 'relative',
          overflow: 'hidden',
          alignItems: 'center'
        }}
      >
        {/* {(status?.key == 152 || status?.key == 151) && (
          <Div
            background={theme.colors.purpleBold}
            p="6px 20px" 
            radius="0 24px 0 16px" 
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)"
            }}
          >
            <Text 
              color="white" 
              size={theme.fonts.size.sm}
              weight="bold"
            >
              {status?.tab}
            </Text>
          </Div>
        )} */}
        <Col>
          {<Text color={styles.color} size={theme.fonts.size.sm} mb="5px">
            {survey.categoryName}
          </Text>}
          <Text
            weight={theme.fonts.weight.bold}
            color={styles.color}
            size={theme.fonts.size.h6}
          >
            {survey.name}
          </Text>
        </Col>
        <Col justify="center">
          <ChevronRightIcon
            width="32px"
            height="32px"
            stroke={styles.color}
          />
        </Col>
      </Div>
    );
  };
  
const SurveyCardSkeleton = ({ isMobile }) => {
    return (
        <Div
        width={!isMobile ? "31%" : "100%"}
        minHeight="120px"
        radius="24px"
        background={theme.colors.blue100}
        align="left"
        p="20px 17px 20px 24px"
        style={{ 
            position: 'relative',
            overflow: 'hidden',
            alignItems: 'center'
        }}
        >
        <Col style={{ width: '80%' }}>
            <Skeleton.Input 
            active 
            size="small" 
            style={{ 
                width: '60%', 
                height: '16px',
                marginBottom: '5px' 
            }} 
            />
            <Skeleton.Input 
            active 
            size="small" 
            style={{ 
                width: '90%', 
                height: '24px' 
            }} 
            />
        </Col>
        <Col justify="center">
            <Skeleton.Avatar 
            active 
            size="large" 
            style={{ 
                width: '32px', 
                height: '32px',
                borderRadius: '50%' 
            }} 
            />
        </Col>
        </Div>
    );
};
  
export const SurveysSkeleton = ({ count = 3, isMobile }) => {
    return (
        <>
        {Array(count).fill().map((_, index) => (
            <SurveyCardSkeleton key={index} isMobile={isMobile} />
        ))}
        </>
    );
};